const playlistConstants = {
    GET_PLAYLIST: "GET_PLAYLIST",
    ADD_PLAYLIST: "ADD_PLAYLIST",
    EDIT_PLAYLIST: "EDIT_PLAYLIST",
    DELETE_PLAYLIST: "DELETE_PLAYLIST"
}

export default playlistConstants;
